module.exports = __webpack_public_path__ + "img/logo.1669721740000.png";